import { buildPrompt } from '@/ai/utils/promptBuilder'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import { createSystemMessage, createUserMessage } from '@/ai/utils/promptUtils'

export const buildEntitiesExampleDataPrompt = ({ entities }) => {
  const messages = []

  const systemContent = buildPrompt([systemMessages.EVENT_MODELING_DDD_EXPERT])
  messages.push(createSystemMessage(systemContent))

  const promptSections = []

  promptSections.push({
    title: 'Background entities (JSON format)',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify(entities)
  })

  promptSections.push({
    title: 'Request',
    content: 'Review the entities list provided above, then generate example data for each data field of all provided entities. Generate three rows of example data for each field. If example data already exists, try to provide different values in your response. Each example data value must be at most 30 characters long. The entities and data fields count in the response must match the count of provided entities. Do NOT modify the entity or data field names. The order of the entities and data fields in the response must match the order in the provided entities list.'
  })

  const example = {
    entities: [
      {
        name: 'User',
        fields: [
          { name: 'id', exampleData: ['Example 1', 'Example 2', 'Example 3'] },
          { name: 'fullName', exampleData: ['Example 1', 'Example 2', 'Example 3'] },
          { name: 'age', exampleData: ['Example 1', 'Example 2', 'Example 3'] }
        ]
      },
      {
        name: 'Product',
        fields: [
          { name: 'id', exampleData: ['Example 1', 'Example 2', 'Example 3'] },
          { name: 'productName', exampleData: ['Example 1', 'Example 2', 'Example 3'] },
          { name: 'productType', exampleData: ['Example 1', 'Example 2', 'Example 3'] }
        ]
      }
    ]
  }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonOutputFormatting('entities', JSON.stringify(example))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
